<template>
  <div class="d-flex align-items-center">
    <span class="mr-1 select-label">Site</span>
    <div
      class="d-flex justify-content-between align-items-center select-container w-100"
      @click="handleSelectSite"
    >
      <div class="select-container__pill">
        <b-badge
          v-for="(site, index) in siteSelectedDisplay"
          :id="`tag_site_${index}`"
          :key="index"
          variant="light-primary"
        >
          {{ site }}
        </b-badge>
      </div>
      <feather-icon icon="FilterIcon" size="14"></feather-icon>
    </div>
  </div>
</template>

<script>
import { BBadge } from "bootstrap-vue"
import { mapGetters } from "vuex"

export default {
  name: "SiteSelect",
  components: {
    BBadge,
  },
  computed: {
    ...mapGetters("siteStore", ["siteOptions"]),

    siteSelected() {
      return this.siteOptions.map((site) => site.text)
    },

    siteSelectedDisplay() {
      if (this.siteSelected?.length) {
        if (this.siteSelected.length === 1) {
          return this.siteSelected
        }

        const isOverCharacter =
          this.siteSelected[0].length + this.siteSelected[1].length > 20

        if (this.siteSelected.length === 2 && !isOverCharacter) {
          return this.siteSelected
        }

        if (!isOverCharacter) {
          const count = this.siteSelected.length - 2
          return [this.siteSelected[0], this.siteSelected[1], `+${count}`]
        }

        if (this.siteSelected[0].length > 20) {
          const count = this.siteSelected.length - 1
          return [`${this.siteSelected[0].slice(0, 19)}...`, `+${count}`]
        }

        const count = this.siteSelected.length - 1
        return [this.siteSelected[0], `+${count}`]
      }

      return []
    },
  },
  methods: {
    handleSelectSite() {
      this.$emit("onSelectSite")
    },
  },
}
</script>

<style lang="scss" scoped>
.select-container {
  padding: 0.438rem 1rem;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
  height: 2.714rem;
  column-gap: 5px;
  cursor: pointer;
  min-width: 260px;
}

.select-container__pill {
  display: flex;
  column-gap: 5px;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.select-label {
  font-size: 12px;
}
</style>
